export default __webpack_public_path__ + "static/media/canvasAndFramedLargeCanvasFramedBlack.db1435bd.jpg";